<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <ribbon v-if="ribbonText" position="right-bottom" :fixed="true" url="" :text="ribbonText" color="#F12510"
            class="no-print"/>
    <notifications></notifications>
    <sidebar-fixed-toggle-button/>
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
      :logo="brandedLogo"
      class="no-print"
      :maximised-sidebar="maximisedSidebar == 'true'">
      <template slot-scope="props" slot="links">
        <sidebar-item
          v-if="$auth.can({statistics: 'read'}, 'permissions')"
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'mdi mdi_icon mdi-24px mdi-view-dashboard-outline',
            path: '/dashboard'
          }"/>
        <!-- user search -->
        <sidebar-item
          v-if="$auth.can({account: 'read'}, 'permissions')"
          :link="{
            name: $t('sidebar.userSearch'),
            icon: 'mdi mdi_icon mdi-24px mdi-account-search-outline',
            path: '/account/search'
          }"/>
        <!-- Operator reports configuration -->
        <sidebar-item
          :link="{
            name: $t('sidebar.operatorReportsSubmenu'),
            icon: 'mdi mdi_icon mdi-24px mdi-bus',
          }">
          <sidebar-item
            v-if="$auth.can({operator_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.operatorTicketsReport'),
              path: '/operator-reports/tickets'
            }"/>
          <sidebar-item
            v-if="$auth.can({operator_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.operatorJourneysCountReport'),
              path: '/operator-reports/journeys-count-report'
            }"/>
          <sidebar-item
            v-if="$auth.can({operator_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.journeysStatsReports'),
              path: '/operator-reports/journeys-stats'
            }"/>
          <sidebar-item
            v-if="$auth.can({operator_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.operatorRoutesStatsReport'),
              path: '/operator-reports/routes-stats'
            }"/>
        </sidebar-item>
        <!-- Reports configuration -->
        <sidebar-item
          :link="{
            name: $t('sidebar.reportsSubmenu'),
            icon: 'mdi mdi_icon mdi-24px mdi-file-chart-outline',
          }">
          <sidebar-item
            v-if="$auth.can({report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.creditDebitReport'),
              path: '/reports/credit-debit'
            }"/>
          <sidebar-item
            v-if="$auth.can({report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.distributorsSummaryReport'),
              path: '/reports/distributors'
            }"/>
          <sidebar-item
            v-if="$auth.can({report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.soldSeasonTicketsReport'),
              path: '/reports/sold-season-tickets'
            }"/>
          <sidebar-item
            v-if="$auth.can({report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.canceledSeasonTicketsReport'),
              path: '/reports/canceled-season-tickets'
            }"/>
          <sidebar-item
            v-if="$auth.can({report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.seasonTicketsCountReport'),
              path: '/reports/season-tickets-count'
            }"/>
          <sidebar-item
            v-if="$auth.can({inspection_locks_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.inspectionLocksReport'),
              path: '/reports/inspection-locks'
            }"/>
          <sidebar-item
            v-if="$auth.can({journeys_by_stop_municipalities_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.journeysByStopMunicipalitiesReport'),
              path: '/reports/journeys-by-stop-municipalities'
            }"/>
          <sidebar-item
            v-if="$auth.can({emv_taps_summary_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.emvTapsSummaryReport'),
              path: '/reports/emv-taps-summary-report'
            }"/>
          <sidebar-item
            v-if="$auth.can({emv_success_payment_summary_report: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.emvSuccessPaymentsSummaryReport'),
              path: '/reports/emv-success-payments-summary-report'
            }"/>
        </sidebar-item>
        <sidebar-item v-if="$auth.can({reporting_profile: 'read'}, 'permissions')"
                      :link="{
                name: $t('sidebar.reportingProfiles'),
                icon: 'mdi mdi_icon mdi-24px mdi-file-table-box-outline',
                path: '/reports/reporting-profiles'
              }"/>
        <!-- Identity and Access management (Admins, SystemAccounts) -->
        <sidebar-item
          :link="{
            name: $t('sidebar.iam'),
            icon: 'mdi mdi_icon mdi-24px mdi-account-outline'
          }">
          <sidebar-item
            v-if="$auth.can({system_account: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.systemAccounts'),
              path: '/system/system-accounts'
            }"/>
          <sidebar-item
            v-if="$auth.can({role: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.roles'),
              path: '/system/roles'
            }"/>

        </sidebar-item>
        <!-- Teams & Lock -->
        <!-- Identity and Access management (Admins, SystemAccounts) -->
        <sidebar-item
          :link="{
            name: $t('sidebar.inspectors'),
            icon: 'mdi mdi_icon mdi-24px mdi-police-badge-outline',
          }">
          <sidebar-item
            v-if="$auth.can({inspector_team: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.inspector_teams'),
            path: '/system/inspector-teams'
          }"/>
          <sidebar-item
            v-if="$auth.can({pt_lock: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.pt_locks'),
            path: '/system/pt-locks'
          }"/>
        </sidebar-item>

        <!-- Data configuration -->
        <sidebar-item
          :link="{
            name: $t('sidebar.dataSubmenu'),
            icon: 'mdi mdi_icon mdi-24px mdi-database-search-outline'
          }">
          <sidebar-item
            v-if="$auth.can({money_claim: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.moneyClaims'),
            path: '/data/money-claims'
          }"/>
          <sidebar-item
            v-if="$auth.can({account_deletions: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.accountDeletions'),
            path: '/data/account-deletions'
          }"/>
          <sidebar-item
            v-if="$auth.can({top_up: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.topUp'),
            path: '/data/top-ups'
          }"/>
          <sidebar-item
            v-if="$auth.can({pos_transaction: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.posTransactions'),
            path: '/data/pos-transactions'
          }"/>
          <sidebar-item
            v-if="$auth.can({card_identity: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.cards'),
            path: '/data/cards'
          }"/>
          <sidebar-item
            v-if="$auth.can({pt_schedule: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.ptSchedules'),
              path: '/data/pt-schedules',
            }"/>
          <sidebar-item
            v-if="$auth.can({inspection_event: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.inspectionEvents'),
            path: '/data/inspection-events'
          }"/>
          <sidebar-item
            v-if="$auth.can({emv_tap: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.emvTaps'),
            path: '/data/emv-taps'
          }"/>
          <sidebar-item
            v-if="$auth.can({external_emv_tap: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.externalEmvTaps'),
            path: '/data/external-emv-taps'
          }"/>
          <sidebar-item
            v-if="$auth.can({emv_clearing: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.emvClearings'),
            path: '/data/emv-clearings'
          }"/>
          <sidebar-item
            v-if="$auth.can({emv_cut_over: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.emvCutOvers'),
            path: '/data/emv-cut-overs'
          }"/>
          <sidebar-item
            v-if="$auth.can({audit_log: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.auditLogs'),
            path: '/data/audit-logs'
          }"/>
          <sidebar-item
            v-if="$auth.can({email_message: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.emails'),
            path: '/data/emails'
          }"/>
          <sidebar-item
            v-if="$auth.can({bloom_filters: 'read'}, 'permissions')"
            :link="{
            name: $t('sidebar.offlineFilters'),
            path: '/data/offline-filters'
          }"/>
        </sidebar-item>
        <!-- System configuration -->
        <sidebar-item
          :link="{
            name: $t('sidebar.systemConfiguration'),
            icon: 'mdi mdi_icon mdi-24px mdi-wrench-outline'
          }">
          <sidebar-item
            v-if="$auth.can({fare_group: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.fareGroups'),
              path: '/config/fare-groups',
            }"/>
          <sidebar-item
            v-if="$auth.can({operator: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.operators'),
              path: '/config/operators',
            }"/>
          <sidebar-item
            v-if="$auth.can({discount: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.discounts'),
              path: '/config/discounts',
            }"/>
          <sidebar-item
            v-if="$auth.can({pt_mapping: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.ptMappings'),
              path: '/config/pt-mappings',
            }"/>
          <sidebar-item
            v-if="$auth.can({municipality: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.municipalities'),
              path: '/config/municipalities',
            }"/>
          <sidebar-item
            v-if="$auth.can({bot_client: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.botClients'),
              path: '/config/bot-clients',
            }"/>

          <sidebar-item
            v-if="$auth.can({pt_zone: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.ptZones'),
              path: '/config/pt-zones',
            }"/>
          <sidebar-item
            v-if="$auth.can({pt_stop: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.ptStops'),
              path: '/config/pt-stops',
            }"/>
          <sidebar-item
            v-if="$auth.can({notification_configuration: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.notificationConfigs'),
              path: '/config/notification-configs',
            }"/>
          <sidebar-item
            v-if="$auth.can({email_template: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.emailTemplates'),
              path: '/config/email-templates',
            }"/>
          <sidebar-item
            v-if="$auth.can({distributors: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.distributors'),
              path: '/config/distributors',
            }"/>
          <sidebar-item
            v-if="$auth.can({season_tickets: 'read'}, 'permissions')"
            :link="{
              name: $t('sidebar.seasonTickets'),
              path: '/config/season-tickets',
            }"/>
        </sidebar-item>

        <!-- End system configuration -->
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <sidebar-share v-if="ribbonText!==''" :with-documentation="true" :background-color.sync="sidebarBackground"
                   :with-sidebar="true"></sidebar-share>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <div key="_main">
            <router-view></router-view>
          </div>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter && companyName" :company-name="companyName"
                      :company-url="companyUrl"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import {mapActions} from "vuex";
import swal from 'sweetalert2';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions';
import Ribbon from 'vue-ribbon';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    swal,
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
    Ribbon
  },
  data() {
    return {
      sidebarBackground: process.env.VUE_APP_SIDEBAR_BACKGROUND ? process.env.VUE_APP_SIDEBAR_BACKGROUND : 'vue', //vue|blue|orange|green|red|primary
      brand: process.env.VUE_APP_BRAND,
      ribbonText: process.env.VUE_APP_RIBBON_TEXT,
      companyName: process.env.VUE_APP_COMPANY_NAME,
      companyUrl: process.env.VUE_APP_COMPANY_URL,
      maximisedSidebar: process.env.VUE_APP_MAXIMISED_SIDEBAR
    };
  },
  methods: {
    ...mapActions(["ResetInteractionError"]),
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  computed: {
    brandedLogo() {
      if (this.brand) {
        return '/img/' + this.brand + '/logo.png';
      }
      return '';
    }
  },
  watch: {
    "$store.state.layout.error"(error) {
      if (error != null) {
        this.$notify({
          group: 'error',
          type: 'danger',
          title: 'ERROR',
          message: error,
          icon: 'tim-icons icon-alert-circle-exc',
          timeout: 0
        });
      }
    },
    "$store.state.layout.interactionError"(errorText) {
      if (errorText != null) {
        swal.fire({
          title: this.$t('alert.failureTitle'),
          text: errorText,
          type: 'error',
          buttonsStyling: false,
          confirmButtonText: this.$t('alert.closeButtonLbl'),
          confirmButtonClass: 'btn btn-primary',
          onClose: this.ResetInteractionError
        });
      }
    },
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
